import { IResponseModel } from "@models/dto/Rocketta/LicenseServer/Models/IResponseModel";
import { AxiosResponse } from "axios";
import LicenseServerBaseApi from "./baseApi";
import { IEditProductRequest } from "@models/dto/Rocketta/LicenseServer/Models/Products/IEditProductRequest";
import { IGetProductsRequest } from "@models/dto/Rocketta/LicenseServer/Models/Products/IGetProductsRequest";
import { IProductInfo } from "@models/dto/Rocketta/LicenseServer/Models/Products/IProductInfo";
import { ICreateProductRequest } from "@models/dto/Rocketta/LicenseServer/Models/Products/ICreateProductRequest";

export class ProductApi {
  static getProducts(data: IGetProductsRequest): Promise<AxiosResponse<IResponseModel<IProductInfo[]>>> {
    return LicenseServerBaseApi.get<IProductInfo[]>("/Product");
  }

  static getProduct(id: number): Promise<AxiosResponse<IResponseModel<IProductInfo>>> {
    return LicenseServerBaseApi.get<IProductInfo>("/Product/" + id.toString());
  }

  static editProduct(data: IEditProductRequest): Promise<AxiosResponse<IResponseModel<IProductInfo>>> {
    return LicenseServerBaseApi.putWrapped<IProductInfo>("/Product/Edit", data);
  }

  static createProduct(data: ICreateProductRequest): Promise<AxiosResponse<IResponseModel<IProductInfo>>> {
    return LicenseServerBaseApi.postWrapped<IProductInfo>("/Product/Create", data);
  }
}
